import { Resources } from 'constants/resources';

import { AxiosResponse } from 'axios';
import { updateProviderAccountWorkTeamUsers } from 'config/requests/providerAccounts';
import { ProviderAccountsWorkTeamSelect } from 'pages/Finance/ProviderAccounts/components/ProviderAccountsWorkTeamSelect/ProviderAccountsWorkTeamSelect';
import { queryClient } from 'providers/queryClient';
import { RecordContextProvider, SimpleForm, useNotify } from 'react-admin';
import { FieldValues, SubmitHandler } from 'react-hook-form';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { AutocompleteMultiselectInput } from 'shared/react-admin/Inputs';
import { ProviderAccount } from 'types/embedded/providerAccount';
import { User } from 'types/embedded/user';

import { StyledDialog } from './WorkTeamUsersAddDialog.styled';

type WorkTeamUsersAddDialogProps = {
  provider: ProviderAccount;
  onClose: () => void;
} & DialogProps;

export const WorkTeamUsersAddDialog = ({
  open,
  provider,
  onClose,
}: WorkTeamUsersAddDialogProps) => {
  const notify = useNotify();

  const handleSubmit: SubmitHandler<FieldValues> = async (data) => {
    if (provider?.id) {
      try {
        await updateProviderAccountWorkTeamUsers(provider.originId, data);
        await queryClient.refetchQueries({ queryKey: [Resources.ProviderAccounts] });

        notify(`Ответственные для настройки доступа ID ${provider?.originId} добавлены`, {
          type: 'success',
        });
        onClose();
      } catch {
        (err: AxiosResponse) => {
          notify(err?.data?.detail, { type: 'error' });
        };
      }
    }
  };

  return (
    <StyledDialog onClose={onClose} open={open} width="640px">
      <SimpleForm
        defaultValues={{
          members: provider?.members?.map((m) => m['@id']),
        }}
        onSubmit={handleSubmit}
        toolbar={<></>}
      >
        <RecordContextProvider value={provider}>
          <CardHeader
            appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
            title="Добавление ответственных"
            titleSize="smallBold"
          />
          <CardContent sx={{ width: '100%' }}>
            <ProviderAccountsWorkTeamSelect workTeam={provider?.workTeam} />

            <AutocompleteMultiselectInput
              filterToQuery={(searchText: string) => ({
                fullName: searchText,
              })}
              fullWidth
              getOptionLabel={(record: User) => `${record?.firstName} ${record?.lastName}`}
              helperText={false}
              label="Сотрудники"
              name="members"
              optionValue="@id"
              options={provider?.workTeam?.members || []}
              size="small"
              source="members"
            />
          </CardContent>
          <CardActionsButtons
            rightActionsSlot={[
              <CancelButton key="cancel-button" onClick={onClose} variant="outlined" />,
              <Button key="save-button" label="Сохранить" type="submit" variant="contained" />,
            ]}
          />
        </RecordContextProvider>
      </SimpleForm>
    </StyledDialog>
  );
};
